<router-outlet></router-outlet>

<p-toast [life]="5000"></p-toast>
<p-confirmDialog [closable]="false" [styleClass]="'alert-dialog'"></p-confirmDialog>
